import { createAction } from "@reduxjs/toolkit"
import { ISmartScaleMetric, SmartScaleMetric } from "../interfaces/api/chs/getAllSmartScaleMetric"

export enum BcaActionNames {
	SET_ALL_METRIC_NAMES = "SET_ALL_METRIC_NAMES",
}

export const setAllBcaMetricNames = createAction<Record<SmartScaleMetric, Partial<ISmartScaleMetric>> | undefined | null>(BcaActionNames.SET_ALL_METRIC_NAMES)
